module.exports = __webpack_public_path__ + "img/one-step.bcd78446.svg";